import { makeStyles } from '@material-ui/core/styles';
import { howden } from '../../themes/howdenTheme';

export const useLandingStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    overflowX: 'hidden',
  },
  hero: {
    background: `linear-gradient(135deg, ${howden.mossGreen} 0%, ${howden.rosewood} 100%)`,
    color: howden.white,
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(10),
  },
  heroContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  eyebrow: {
    marginTop: theme.spacing(3),
    color: howden.pistachio,
    letterSpacing: '0.12em',
    fontWeight: 600,
  },
  heroTitle: {
    color: howden.white,
    marginTop: theme.spacing(1),
  },
  heroSubtitle: {
    color: howden.grey10,
    maxWidth: 640,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    fontWeight: 400,
  },
  signInButton: {
    backgroundColor: howden.teal,
    color: howden.mossGreen,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    '&:hover': {
      backgroundColor: howden.pistachio,
    },
  },
  heroHelper: {
    marginTop: theme.spacing(2),
    color: howden.grey10,
  },
  errorText: {
    marginTop: theme.spacing(2),
    backgroundColor: 'rgba(0,0,0,0.2)',
    padding: theme.spacing(1, 2),
    borderRadius: theme.shape.borderRadius,
  },
  section: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  altSection: {
    backgroundColor: howden.grey5,
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
  },
  sectionIntro: {
    maxWidth: 720,
    margin: '0 auto',
    marginBottom: theme.spacing(5),
    color: howden.grey60,
  },
  cardGrid: {
    marginTop: theme.spacing(2),
  },
  card: {
    height: '100%',
    padding: theme.spacing(1),
  },
  cardIcon: {
    fontSize: 36,
    color: howden.cobaltBlue,
    marginBottom: theme.spacing(1),
  },
  cardTitle: {
    marginBottom: theme.spacing(1),
  },
  providesBox: {
    marginTop: theme.spacing(6),
    padding: theme.spacing(4),
    backgroundColor: howden.white,
    border: `1px solid ${howden.grey10}`,
    borderRadius: theme.shape.borderRadius,
  },
  providesTitle: {
    marginBottom: theme.spacing(2),
  },
  providesItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
  },
  providesIcon: {
    color: howden.mossGreen,
    fontSize: 20,
    marginTop: 2,
  },
  footerCta: {
    background: `linear-gradient(135deg, ${howden.cobaltBlue} 0%, ${howden.mossGreen} 100%)`,
    color: howden.white,
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  footerContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  footerTitle: {
    color: howden.white,
    marginBottom: theme.spacing(3),
  },
  footerHelper: {
    marginTop: theme.spacing(2),
    color: howden.grey10,
  },
}));
